module.exports = __webpack_public_path__ + "img/c91250a.png";